export const environment = {
  production: false,
  recaptcha: {
    enabled: false,
    /** reCAPTCHA for testing purposes only. Please replace it for production use */
    siteKey: '6LfUhzYoAAAAAJ1F6vgzNJUT8G-zDXk1Eh5owOxk',
  },
  consoleLogErrors: true,
};
